import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Brows from "./pages/Brows";
import Loader from "./components/Loader";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Gallery from "./pages/Gallery";
import Footer from "./components/Footer";

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleLoaded = () => {
    setIsLoaded(true); // Postavi stanje kada se učitavanje završi
  };

  return (
    <>
      <Router>
        {isLoaded ? (
          <>
            <Navbar />

            <div className="App">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/o-meni" element={<About />} />
                <Route path="/puder-obrve" element={<Brows />} />
                <Route path="/galerija-radova" element={<Gallery />} />
                <Route path="/najcesce-postavljena-pitanja" element={<FAQ />} />
                <Route path="/kontakt" element={<Contact />} />
              </Routes>
            </div>

            <Footer />
          </>
        ) : (
          <Loader onLoaded={handleLoaded}>Loading...</Loader>
        )}
      </Router>
    </>
  );
}

export default App;
